import { computed, defineComponent, inject } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import { orderServiceKey } from "../../../infrastructure/gfo_api/order_service";
import { priceFormatterKey } from "../../../infrastructure/price_formatter";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

const PRODUCT_ID_SIM = 35;

export default defineComponent({
  template: html,
  setup() {
    // Injections
    const { t } = useI18n();
    const orderService = inject(orderServiceKey);
    const priceFormatter = inject(priceFormatterKey);

    // vars und computed
    const simVariants = computed(() => {
      return orderService?.availableVariants?.value?.filter((v) => v.product_id == PRODUCT_ID_SIM) ?? [];
    });
    const currentVariantId = computed(() => {
      return orderService?.currentItems?.value?.find((it) => it.product_id == PRODUCT_ID_SIM)?.product_variant_id ?? 0;
    });
    const vatType = computed(() => {
      return orderService?.currentVatType.value;
    });

    // methods
    // Varianten desselben Produkts sind gegenseitig exklusiv; der Server ersetzt die
    // vorherige Auswahl automatisch (analog zu OptionsFixIp)
    const onSelect = async (variantId: number) => {
      if (variantId == currentVariantId.value) {
        return;
      }
      await orderService?.addToCart(variantId, "", 1);
    };

    // aktuell gibt es keine Pflichtfelder; die Methode existiert, damit ConfigsMobile
    // sie wie die übrigen Kind-Komponenten einheitlich vor 'next' abfragen kann
    const isValid = computed(() => true);

    const validate = async () => {
      return isValid.value;
    };

    return {
      t,
      simVariants,
      currentVariantId,
      priceFormatter,
      vatType,
      onSelect,
      isValid,
      validate,
    };
  },
} as any);
